import { ActionReducerMap } from '@ngrx/store';

import { UserParamReducer } from './userparam.reducer';
import { RegistrationEventReducer } from './registrationevent.reducer';
import { RegistrationEntryReducer } from './registrationentry.reducer';
import { IAppState } from '../../models/app.state.model';

export const RootReducers: ActionReducerMap<IAppState, any> = {
    userParam: UserParamReducer,
    registrationEvent: RegistrationEventReducer,
    registrationEntry: RegistrationEntryReducer
};